import { TopRankTable } from '../TopRankTable'
import { withTopCharacterTable } from './withTopCharacterTable'

const ConnectedTopCharacterTable = withTopCharacterTable(TopRankTable)

export { ConnectedTopCharacterTable as TopCharacterTable }
